<template>
  <d-container fluid id="app" class="h-100 p-0">
    <router-view />
  </d-container>
</template>

<script>
import interceptor from '_common/runs/interceptor';

export default {
  name: 'app',
  created() {
    interceptor();
  },
};
</script>
